import React, {PropTypes} from 'react';
import {Link} from 'react-router-dom';

import { history } from '../../../store';

import * as color from '../../../constants/colors';


class RhinoAlert extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      closing: false,
      bodyTop: 0,
      marginOffset: 0,
    };

    // Bind event listeners
    this.adjustHeight = this.adjustHeight.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.adjustHeight, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.adjustHeight, false);
  }

  componentWillUpdate(nextProps, nextState) {
    if(this.state.open !== nextProps.open) {
      if(this.state.open && !nextProps.open && !this.state.closing) {
        this.closeAlert();
      } 
      if(nextProps.open) {
        this.openAlert();
      }
    }
  }

  getAlertBody() {
    let alert = null;
    let alerts = document.getElementsByClassName('alertBody');
    for(let i = 0; i < alerts.length; i++) {
      if(getComputedStyle(alerts[i], null).display === 'block') {
        alert = alerts[i];
        break;
      }
    }
    return alert;
  }

  adjustHeight() {
    let foundAlert = this.getAlertBody();
    if(foundAlert) {
      let offset = (window.innerHeight - (foundAlert.offsetHeight + 128)) / 2;
      this.setState({ marginOffset: offset > 0 ? offset + 'px' : 0 });
    }
  }

  openAlert() {
    this.setState({ open: true }, () => {
      let alert = null;
      do {
        alert = this.getAlertBody();
        setTimeout(() => {
          if(alert) {
            let offset = (window.innerHeight - (alert.offsetHeight + 128)) / 2;
            this.setState({ 
              bodyTop: '64px',
              marginOffset: offset > 0 ? offset + 'px' : 0, 
            });
          }
        }, 25);
      } while(!alert);
    });
  }

  closeAlert() {
    this.setState({ 
      closing: true,
      bodyTop: '0',
    });
    setTimeout(() => {
      this.setState({
        open: false,
        closing: false,
      });
    }, 400)
  }

  alertStyles() {
    return {
      display: this.state.open ? 'block' : 'none', 
    }
  }

  alertNav(page) {
    // this.closeAlert();
    history.push('/' + page);
  }

  hasLink() {
    return this.props.config && this.props.config.linkLabel && this.props.config.linkSrc;
  }

  hasFullLink() {
    return this.props.config && this.props.config.linkLabel && this.props.config.linkFullSrc;
  }

  render() {

    return (
      <div 
        className={this.state.closing ? 'RhinoAlert out' : 'RhinoAlert'} 
        style={this.alertStyles()}>
        <div 
          className='alertBody'
          style={{
            display: this.state.open ? 'block' : 'none',
            top: this.state.bodyTop,
            marginTop: this.state.marginOffset,
            marginBottom: this.state.marginOffset === 0 ? '64px' : 0,
          }}>
          <div 
            className='alertText'
            dangerouslySetInnerHTML={{
              __html: this.props.alertText,
            }} />
          {this.hasLink() ?
            <Link to={this.props.config.linkSrc} style={{textDecoration: 'none'}}>
              <div className='alertLink' onClick={this.props.closeMethod.bind(this)}>
                {this.props.config.linkLabel}
              </div>
            </Link> :
            null
          }
          {this.hasFullLink() ?
            <a href={this.props.config.linkFullSrc} style={{textDecoration: 'none'}} target='_blank'>
              <div className='alertLink' onClick={this.props.closeMethod.bind(this)}>
                {this.props.config.linkLabel}
              </div>
            </a> :
            null
          }
          <div className='alertIcon'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='alertButton'>
            <button className={'alertOk actionButton'} onClick={this.props.closeMethod.bind(this)}>OK</button>
          </div>
        </div>
      </div>
    );
  }
}
export default RhinoAlert;